import type { MakeCall } from '../createMakeCall';
import { BillingInformation } from '../types/BillingInformation';

export interface APIUserMultiBillingData {
  billingInfos: BillingInformation[];
  count: number;
}

// Temporary query limit until we have pagination/scroll
const TEMP_QUERY_LIMIT = {
  limit: 50,
};

const getMultiBillingInformation = (makeCall: MakeCall) => () =>
  makeCall<APIUserMultiBillingData>('GET', `/api/v2/billing/billing-info`, {
    query: TEMP_QUERY_LIMIT,
  }).then(res => ({
    ...res,
    data: {
      billingInformation: res.data?.billingInfos ?? [],
      count: res.data.count,
    },
  }));

export { getMultiBillingInformation };
